import { useState } from 'react';
import Modal from 'src/components/common/Modal/Modal';
import styled from 'styled-components';
import CardForm from '../components/settings/CardForm/CardForm';
import SettingsForm from '../components/settings/SettingsForm/SettingsForm';

function SettingsPage() {
    const [showModal, setShowModal] = useState(false);

    const toggleModal = () => setShowModal(prev => !prev);

    return (
        <Container>
            <SettingsForm toggleModal={toggleModal} />

            <Modal
				showModal={showModal}
				toggleModal={toggleModal}
			>
                <CardForm
					toggleModal={toggleModal}
					/>
            </Modal>
        </Container>
    );
}

export default SettingsPage;

// Same centred column as the Subscriptions page
export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
    max-width: 420px;
    margin: 0 auto;
    padding: 10px 16px 60px;
    box-sizing: content-box;

    @media only screen and (max-width: 768px) {
        padding-top: 24px;
        box-sizing: border-box;
        max-width: 452px;
    }
`